import type { Action } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';
import type { ReduxActionMethod } from '../types';
import { createAction } from './createAction.ts';

export function createActionBuilder<
  ActionType extends string,
  ActionObject extends object,
  TArgs extends [...unknown[]]
>(type: ActionType, method: (...args: TArgs) => ActionObject): ReduxActionMethod<TArgs> {
  return createAction<TArgs, Action<ActionType>>(
    (...args: TArgs) =>
      (dispatch: Dispatch<ActionObject & { type: ActionType }>) => {
        dispatch({ type, ...method(...args) });
      }
  );
}